import React, { useLayoutEffect } from 'react';
import '@timelyapp/design-system/theme-timely-light.css';
import '../styles/define-theme-variables.scss';
import '@timelyapp/react/style.css';

import.meta.hot?.accept('@timelyapp/design-system/theme-timely-light.css', () => {
  console.log('Hot update @memoryai/design-system/theme-timely-light.css');
});

type Theme = 'timely-light';
interface ThemeInfo {
  dark: boolean;
}
const themeVariants: Record<Theme, ThemeInfo> = {
  'timely-light': {
    dark: false,
  },
};

const ThemeContext = React.createContext<{ theme: Theme; setTheme: (theme: Theme) => void }>({
  theme: 'timely-light',
  setTheme: () => {},
});
ThemeContext.displayName = 'ThemeContext';

interface ThemeProviderProps {
  children?: React.ReactNode;
  defaultTheme?: Theme;
}
export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  defaultTheme = 'timely-light',
}) => {
  const [theme, setTheme] = React.useState<Theme>(defaultTheme);
  useThemeBodyClass(theme);
  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};

export const useThemeBodyClass = (theme: Theme) => {
  useLayoutEffect(() => {
    Array.from(document.documentElement.classList).forEach(cls => {
      if (cls.startsWith('theme-')) {
        document.documentElement.classList.remove(cls);
      }
    });
    document.documentElement.classList.add(`theme-${theme}`);
  }, [theme]);
};

export const useCurrentThemeContext = () => {
  const { theme, setTheme } = React.useContext(ThemeContext);
  return { theme, setTheme };
};

export const useCurrentThemeIsDark = () => {
  return themeVariants[useCurrentTheme()].dark;
};

export const useCurrentTheme = () => useCurrentThemeContext().theme;
